import {
  adsApi,
  GetHotelsInlineAdsRequest,
  GetHotelsInlineAdsResponse,
  ResponseEnum,
} from "@b2bportal/ads-api";
import { axiosInstance } from "@hopper-b2b/api";

export const getHotelsInlineAds = async (
  request: GetHotelsInlineAdsRequest
): Promise<GetHotelsInlineAdsResponse> => {
  const res = await adsApi(axiosInstance).apiV0AdsHotelsInlineAdsPost(request);
  if (res.data.Response === ResponseEnum.Failure) {
    throw new Error(res.data.errors.join(","));
  }
  return res.data.value;
};
